import { useQuery } from 'react-query';
import { GetCommunityIdea } from 'services/apiServices';
import { Errors, TCommunityIdeaResult } from 'types/ApiServicesTypes';

export default function useGetCommunityIdea(ideaId?: number) {
  const objQuery = useQuery<TCommunityIdeaResult, Errors>(
    ['GetCommunityIdea', ideaId],
    async () => {
      if (ideaId) return await GetCommunityIdea(ideaId);
      else return {} as TCommunityIdeaResult;
    },
  );
  return objQuery;
} 